/* Fairways Giveaway — storefront UI: nav, product form, AJAX cart drawer, cart page, rules TOC. */
(function () {
  'use strict';
  var FW = window.FW || { cartType: 'drawer', routes: { root: '/', cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change' } };
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* One title size per product grid, limited by its widest rendered name.
     Measure actual uppercase glyphs so variable-font width is respected. */
  var titleGroups = [], titleFrame = 0, titleWidths = new WeakMap();
  function fitCardTitles() {
    titleFrame = 0;
    titleGroups.forEach(function (group) {
      var visible = group.titles.filter(function (title) { return title.getBoundingClientRect().width > 0; });
      visible.forEach(function (title) { title.setAttribute('data-title-fit', ''); });
      var sizes = visible.map(function (title) {
        var text = $('.card__title-text', title);
        var width = text.getBoundingClientRect().width;
        return width > 0 ? parseFloat(getComputedStyle(title).fontSize) * title.getBoundingClientRect().width / width : Infinity;
      });
      var size = Math.floor(Math.min.apply(Math, sizes) * 10) / 10;
      if (!Number.isFinite(size) || size <= 0) return;
      group.titles.forEach(function (title) { title.style.setProperty('--card-title-size', size + 'px'); });
    });
  }
  function queueTitleFit() {
    if (!titleFrame) titleFrame = requestAnimationFrame(fitCardTitles);
  }
  var titleObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(function (entries) {
    entries.forEach(function (entry) {
      if (titleWidths.get(entry.target) !== entry.contentRect.width) {
        titleWidths.set(entry.target, entry.contentRect.width);
        queueTitleFit();
      }
    });
  }) : null;
  function initCardTitles() {
    if (titleObserver) titleObserver.disconnect();
    titleGroups = [];
    $$('.card__title').forEach(function (title) {
      if (!$('.card__title-text', title)) return;
      var grid = title.closest('.grid') || title.closest('.card');
      if (!grid) return;
      var group = titleGroups.find(function (item) { return item.grid === grid; });
      if (!group) { group = { grid: grid, titles: [] }; titleGroups.push(group); }
      group.titles.push(title);
    });
    if (titleObserver) titleGroups.forEach(function (group) { titleObserver.observe(group.grid); });
    queueTitleFit();
  }
  initCardTitles();
  window.addEventListener('resize', queueTitleFit, { passive: true });
  document.addEventListener('shopify:section:load', initCardTitles);
  document.addEventListener('shopify:section:unload', function () { requestAnimationFrame(initCardTitles); });
  if (document.fonts) {
    document.fonts.ready.then(queueTitleFit);
    document.fonts.addEventListener('loadingdone', queueTitleFit);
  }

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(msg) {
    var el = $('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    requestAnimationFrame(function () { el.classList.add('is-in'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('is-in'); setTimeout(function () { el.hidden = true; }, 300); }, 3200);
  }

  /* ---------- modal helpers (mobile nav + drawer) ---------- */
  var lastFocus = null;
  function openLayer(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.hidden = false;
    document.documentElement.classList.add('is-locked');
    requestAnimationFrame(function () { el.classList.add('is-open'); });
    var panel = el.querySelector('[role="dialog"]');
    if (panel) setTimeout(function () { (panel.querySelector('button, a, input') || panel).focus(); }, 60);
  }
  function closeLayer(el) {
    if (!el || el.hidden) return;
    el.classList.remove('is-open');
    document.documentElement.classList.remove('is-locked');
    setTimeout(function () { el.hidden = true; }, 280);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function trapFocus(e) {
    var layer = $('[data-cart-drawer].is-open, [data-mobile-nav].is-open');
    if (!layer || e.key !== 'Tab') return;
    var f = $$('a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea', layer).filter(function (n) { return n.offsetParent !== null; });
    if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeLayer($('[data-cart-drawer]')); closeLayer($('[data-mobile-nav]')); var b = $('[data-nav-open]'); if (b) b.setAttribute('aria-expanded', 'false'); }
    trapFocus(e);
  });

  /* ---------- header ---------- */
  var header = $('[data-header]');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-nav-open]')) { t.closest('[data-nav-open]').setAttribute('aria-expanded', 'true'); openLayer($('[data-mobile-nav]')); }
    if (t.closest('[data-nav-close]')) { var b = $('[data-nav-open]'); if (b) b.setAttribute('aria-expanded', 'false'); closeLayer($('[data-mobile-nav]')); }
    if (t.closest('[data-mobile-nav] nav a')) closeLayer($('[data-mobile-nav]'));
    if (t.closest('[data-cart-open]') && FW.cartType === 'drawer' && $('[data-cart-drawer]') && !document.body.classList.contains('template-cart')) {
      e.preventDefault();
      openLayer($('[data-cart-drawer]'));
    }
    if (t.closest('[data-cart-close]')) closeLayer($('[data-cart-drawer]'));
    var change = t.closest('[data-line-change]');
    if (change) {
      e.preventDefault();
      var line = change.closest('[data-line-key]');
      changeLine(line.dataset.lineKey, parseInt(change.dataset.lineChange, 10));
    }
    if (t.closest('[data-recover-toggle]')) { e.preventDefault(); var r = $('#recover'); if (r) { r.classList.toggle('is-open'); var i = $('input', r); if (i) i.focus(); } }
  });

  /* ---------- cart ---------- */
  function updateCount(count) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count; el.hidden = count === 0 && !el.hasAttribute('data-cart-count-keep'); });
  }
  function swapDrawer(sectionsHtml, cart) {
    var html = sectionsHtml && sectionsHtml['cart-drawer'];
    var drawer = $('[data-cart-drawer]');
    if (!html || !drawer) return false;
    var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-drawer]');
    if (!fresh || Number(fresh.dataset.cartItemCount) !== cart.item_count || Number(fresh.dataset.cartTotal) !== cart.total_price) return false;
    var lines = $$('[data-line-key]', fresh);
    if (lines.length !== cart.items.length || lines.some(function (line, index) {
      return line.dataset.lineKey !== cart.items[index].key || Number(line.dataset.lineQuantity) !== cart.items[index].quantity;
    })) return false;
    var wasOpen = !drawer.hidden;
    drawer.innerHTML = fresh.innerHTML;
    if (wasOpen) drawer.classList.add('is-open');
    return true;
  }
  function afterCartChange(sections) {
    return fetch(FW.routes.cart + '.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { if (!r.ok) throw new Error('Cart unavailable'); return r.json(); })
      .then(function (cart) {
        if (swapDrawer(sections, cart)) return cart;
        return fetch(FW.routes.cart + '?sections=cart-drawer', { credentials: 'same-origin', cache: 'no-store' })
          .then(function (r) { if (!r.ok) throw new Error('Cart unavailable'); return r.json(); })
          .then(function (fresh) {
            if (!swapDrawer(fresh, cart)) throw new Error('Cart content unavailable');
            return cart;
          });
      })
      .then(function (cart) {
        updateCount(cart.item_count);
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        return cart;
      });
  }
  function openAfterAdd(sections) {
    return afterCartChange(sections).then(function () { openLayer($('[data-cart-drawer]')); });
  }
  window.FWCart = { openAfterAdd: openAfterAdd };
  function changeLine(key, qty) {
    var drawer = $('[data-cart-drawer]');
    if (drawer) drawer.classList.add('is-busy');
    return fetch(FW.routes.cartChange + '.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty), sections: ['cart-drawer'] })
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status && res.description) toast(res.description);
        if (document.body.classList.contains('template-cart')) { location.reload(); return; }
        return afterCartChange(res.sections);
      })
      .catch(function () { toast('Couldn’t update your cart. Please try again.'); })
      .then(function () { var d = $('[data-cart-drawer]'); if (d) d.classList.remove('is-busy'); });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-bundle-form], [data-drawer-form], [data-merch-form]');
    if (!form || FW.cartType !== 'drawer' || !$('[data-cart-drawer]')) return;
    if (form.matches('[data-drawer-form]') && !event.submitter?.matches('[data-drawer-add]')) return;
    event.preventDefault();
    var id = $('[name="id"]', form), button = $('[data-bundle-add], [data-drawer-add], .card__add', form);
    if (form.dataset.cartBusy === 'true' || id.disabled || !id.value || button.disabled) return;
    var body = new FormData(form);
    body.append('sections', 'cart-drawer');
    body.append('sections_url', location.pathname);
    form.dataset.cartBusy = 'true';
    form.setAttribute('aria-busy', 'true');
    button.disabled = true;
    button.classList.add('is-loading');
    fetch(FW.routes.cartAdd + '.js', { method: 'POST', body: body, credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json().then(function (result) {
          if (!response.ok || result.status) throw new Error(result.description || 'Couldn’t add that item. Please try again.');
          return result;
        });
      })
      .then(function (result) {
        return openAfterAdd(result.sections).catch(function () { location.assign(FW.routes.cart); });
      })
      .catch(function (error) { toast(error.message); })
      .finally(function () {
        form.dataset.cartBusy = 'false';
        form.removeAttribute('aria-busy');
        button.disabled = id.disabled;
        button.classList.remove('is-loading');
      });
  });

  // Cart page quantity inputs
  $$('[data-line-input]').forEach(function (input) {
    var t;
    input.addEventListener('change', function () {
      clearTimeout(t);
      var key = input.closest('[data-line-key]').dataset.lineKey;
      t = setTimeout(function () { changeLine(key, parseInt(input.value, 10) || 0); }, 250);
    });
  });

  function cardSelection(form) {
    var selector = $('[data-card-variant]', form);
    return selector && selector.tagName === 'SELECT' ? selector.options[selector.selectedIndex] : selector;
  }
  function syncCard(form) {
    var card = form.closest('[data-card-purchase]');
    var selected = cardSelection(form);
    if (!card) return;
    var button = $('[data-card-add]', form);
    var label = $('[data-card-add-label]', form);
    var preview = !selected || !Number.isFinite(Number(selected.dataset.price)) || Number(selected.dataset.price) <= 0;
    if (!selected) {
      button.disabled = true;
      label.textContent = form.dataset.unavailableText || 'Unavailable';
      return;
    }
    button.disabled = selected.dataset.available !== 'true' || preview || form.dataset.busy === 'true';
    label.textContent = selected.dataset.available !== 'true' ? form.dataset.soldText : preview ? form.dataset.unavailableText : form.dataset.addText;
    if (!selected.dataset.price) return;
    var now = $('[data-price-now]', card), was = $('[data-price-was]', card);
    var sale = !preview && Number(selected.dataset.compare) > Number(selected.dataset.price);
    if (now) now.textContent = preview ? form.dataset.priceUnavailableText : selected.dataset.priceText;
    if (was) { was.hidden = !sale; was.textContent = selected.dataset.compareText; }
    var price = $('[data-price-wrap]', card);
    if (price) price.classList.toggle('price--sale', sale);
    if ($('fw-card-gallery', card)) {
      card.dispatchEvent(new CustomEvent('fw:variant-image', { detail: {
        imageId: selected.dataset.imageId || '',
        hasVariantImage: selected.dataset.variantImage === 'true'
      } }));
    } else {
      if (selected.dataset.imageHtml && card.dataset.imageId !== selected.dataset.imageId) {
        var imageTemplate = document.createElement('template');
        imageTemplate.innerHTML = selected.dataset.imageHtml;
        var freshImage = imageTemplate.content.querySelector('img');
        var currentImage = $('[data-card-image]', card);
        if (freshImage && currentImage) {
          currentImage.replaceWith(freshImage);
          card.dataset.imageId = selected.dataset.imageId;
        }
      }
      var alternateImage = $('.card__img--alt', card);
      if (alternateImage) alternateImage.hidden = selected.dataset.variantImage === 'true';
    }
    var badge = $('[data-entry-badge]', card);
    if (badge) {
      badge.dataset.price = selected.dataset.price;
      if (window.FWGiveaway) window.FWGiveaway.render();
    }
    if (window.SSEntries) window.SSEntries.setPrice(card, selected.dataset.price);
  }
  function syncCardOptions(form) {
    var selector = $('[data-card-variant]', form);
    var selected = cardSelection(form);
    var values = selected && selected.dataset.options ? JSON.parse(selected.dataset.options) : [];
    $$('[data-card-options] [data-option-index]', form).forEach(function (fieldset, index) {
      $$('[data-option-input]', fieldset).forEach(function (input) { input.checked = input.value === values[index]; });
      var label = $('[data-option-value]', fieldset);
      if (label) label.textContent = values[index] || '';
    });
    var options = $('[data-card-options]', form);
    if (options && selector && values.length) {
      options.hidden = false;
      $('[data-card-select-wrap]', form).hidden = true;
    }
  }
  function initCardOptions(root) {
    $$('[data-card-form]', root).forEach(syncCardOptions);
  }
  initCardOptions(document);
  document.addEventListener('shopify:section:load', function (e) { initCardOptions(e.target); });
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-card-variant], [data-option-input]')) return;
    var form = e.target.closest('[data-card-form]');
    if (!form) return;
    if (e.target.matches('[data-option-input]')) {
      var values = $$('[data-card-options] [data-option-index]', form).map(function (fieldset) {
        var input = $('[data-option-input]:checked', fieldset);
        var label = $('[data-option-value]', fieldset);
        if (label) label.textContent = input ? input.value : '';
        return input ? input.value : null;
      });
      var selector = $('[data-card-variant]', form);
      var match = Array.prototype.find.call(selector.options, function (option) {
        var options = JSON.parse(option.dataset.options);
        return options.every(function (value, index) { return value === values[index]; });
      });
      selector.value = match ? match.value : '';
    } else {
      syncCardOptions(form);
    }
    var status = $('[data-card-status]', form);
    status.textContent = '';
    status.classList.remove('is-error');
    syncCard(form);
  });
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-card-form]');
    if (!form) return;
    var card = form.closest('[data-card-purchase]');
    var selected = cardSelection(form);
    if (form.dataset.busy === 'true' || !selected || !Number.isFinite(Number(selected.dataset.price)) || Number(selected.dataset.price) <= 0 || selected.dataset.available !== 'true') {
      e.preventDefault();
      return;
    }
    if (FW.cartType !== 'drawer' || !$('[data-cart-drawer]')) return;
    e.preventDefault();
    var button = $('[data-card-add]', form);
    var selector = $('[data-card-variant]', form);
    var optionInputs = $$('[data-card-options] [data-option-input]', form);
    var status = $('[data-card-status]', form);
    var body = new FormData(form);
    body.append('sections', 'cart-drawer');
    body.append('sections_url', location.pathname);
    form.dataset.busy = 'true';
    form.setAttribute('aria-busy', 'true');
    button.disabled = true;
    selector.disabled = true;
    optionInputs.forEach(function (input) { input.disabled = true; });
    button.classList.add('is-loading');
    status.textContent = '';
    status.classList.remove('is-error');
    fetch(FW.routes.cartAdd + '.js', { method: 'POST', body: body, credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json().then(function (res) {
          if (!r.ok || res.status) throw new Error(typeof res.description === 'string' ? res.description : form.dataset.errorText);
          return res;
        });
      })
      .then(function (res) {
        status.textContent = form.dataset.addedText;
        return afterCartChange(res.sections)
          .catch(function () { toast(form.dataset.addedText); })
          .then(function () { openLayer($('[data-cart-drawer]')); });
      })
      .catch(function (error) {
        status.textContent = error.message || form.dataset.errorText;
        status.classList.add('is-error');
      })
      .finally(function () {
        form.dataset.busy = 'false';
        form.removeAttribute('aria-busy');
        selector.disabled = false;
        optionInputs.forEach(function (input) { input.disabled = false; });
        button.classList.remove('is-loading');
        syncCard(form);
      });
  });

  /* ---------- product form ---------- */
  $$('[data-product-section]').forEach(function (section) {
    var jsonEl = $('[data-product-json]', section);
    var form = $('[data-product-form]', section);
    if (!jsonEl || !form) return;
    var data = JSON.parse(jsonEl.textContent);
    var idInput = $('[data-variant-id]', form);
    var addBtn = $('[data-add-button]', form);
    var addLabel = $('[data-add-label]', form);
    var priceReady = function (variant) { return variant && Number.isFinite(Number(variant.price)) && Number(variant.price) > 0; };
    var badge = $('[data-entry-badge]', section);
    var qtyInput = $('[data-qty-input]', form);
    var moneyFmt = (window.FWGiveaway && window.FWGiveaway.config.moneyFormat) || '${{amount}}';
    var fmt = function (c) { return moneyFmt.replace(/\{\{\s*\w+\s*\}\}/, (c / 100).toLocaleString('en-US', { minimumFractionDigits: c % 100 ? 2 : 0, maximumFractionDigits: 2 })); };

    function selected() {
      return $$('fieldset[data-option-index]', form).map(function (fs) {
        var c = $('input:checked', fs); return c ? c.value : null;
      });
    }
    function syncBadge() {
      if (!badge) return;
      badge.dataset.quantity = String(Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1));
      if (window.FWGiveaway) window.FWGiveaway.render();
    }
    function onOptionChange() {
      var opts = selected();
      $$('fieldset[data-option-index]', form).forEach(function (fs, i) { var v = $('[data-option-value]', fs); if (v) v.textContent = opts[i]; });
      var v = data.variants.find(function (variant) { return variant.options.every(function (o, i) { return o === opts[i]; }); });
      if (!v) {
        idInput.value = '';
        addBtn.disabled = true; addLabel.textContent = 'Unavailable';
        return;
      }
      idInput.value = v.id;
      addBtn.disabled = !v.available || !priceReady(v);
      addLabel.textContent = !v.available ? 'Sold out' : !priceReady(v) ? form.dataset.unavailableText : 'Add to cart';
      var now = $('[data-price-now]', section), was = $('[data-price-was]', section);
      if (now) now.textContent = priceReady(v) ? fmt(v.price) : form.dataset.priceUnavailableText;
      if (was) { was.hidden = !priceReady(v) || !(v.compare_at_price > v.price); was.textContent = v.compare_at_price ? fmt(v.compare_at_price) : ''; }
      if (badge) badge.dataset.price = String(v.price);
      if (window.SSEntries) window.SSEntries.setPrice(section, v.price);
      if (v.featured_media) showMedia(section, String(v.featured_media.id));
      var url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url.toString());
      syncBadge();
    }
    form.addEventListener('change', function (e) { if (e.target.name && e.target.name.indexOf('option-') === 0) onOptionChange(); });

    $$('[data-qty-step]', form).forEach(function (btn) {
      btn.addEventListener('click', function () {
        qtyInput.value = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + parseInt(btn.dataset.qtyStep, 10));
        syncBadge();
      });
    });
    if (qtyInput) qtyInput.addEventListener('input', syncBadge);

    form.addEventListener('submit', function (e) {
      var submitted = data.variants.find(function (variant) { return String(variant.id) === idInput.value; });
      if (addBtn.disabled || !submitted || !submitted.available || !priceReady(submitted)) { e.preventDefault(); return; }
      if (FW.cartType !== 'drawer' || !$('[data-cart-drawer]')) return;
      e.preventDefault();
      addBtn.disabled = true;
      addBtn.classList.add('is-loading');
      var body = new FormData(form);
      body.append('sections', 'cart-drawer');
      fetch(FW.routes.cartAdd + '.js', { method: 'POST', body: body, credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) { toast(res.description || 'Couldn’t add that item.'); return; }
          return afterCartChange(res.sections).then(function () { openLayer($('[data-cart-drawer]')); });
        })
        .catch(function () { toast('Couldn’t add that item. Please try again.'); })
        .then(function () { addBtn.disabled = false; addBtn.classList.remove('is-loading'); });
    });

    $$('[data-thumb]', section).forEach(function (btn) {
      btn.addEventListener('click', function () { showMedia(section, btn.dataset.thumb); });
    });
  });

  function showMedia(section, id) {
    $$('[data-media-id]', section).forEach(function (s) { s.classList.toggle('is-active', s.dataset.mediaId === id); });
    $$('[data-thumb]', section).forEach(function (t) { t.classList.toggle('is-active', t.dataset.thumb === id); });
  }

  /* ---------- collection sort ---------- */
  var sort = $('[data-sort]');
  if (sort) sort.addEventListener('change', function () {
    var url = new URL(location.href); url.searchParams.set('sort_by', sort.value); url.searchParams.delete('page'); location.href = url.toString();
  });

  /* ---------- rules table of contents ---------- */
  var rules = $('[data-rules-body]'), toc = $('[data-rules-toc]');
  if (rules && toc) {
    var heads = $$('h2, h3', rules);
    if (heads.length > 2) {
      var list = document.createElement('ol');
      heads.forEach(function (h, i) {
        if (!h.id) h.id = 'rule-' + (i + 1);
        var li = document.createElement('li');
        li.className = h.tagName === 'H3' ? 'is-sub' : '';
        var a = document.createElement('a'); a.href = '#' + h.id; a.textContent = h.textContent;
        li.appendChild(a); list.appendChild(li);
      });
      toc.appendChild(list);
      toc.hidden = false;
    }
  }

  /* ---------- reveal on scroll ---------- */
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.section:not(.hero) .wrap > *').forEach(function (el) { el.classList.add('reveal'); io.observe(el); });
  }

  /* ---------- sticky bar waits until the hero (and its countdown) scrolls away ---------- */
  var stickyBar = $('[data-sticky-bar]'), heroEl = $('main .hero');
  if (stickyBar && heroEl && 'IntersectionObserver' in window) {
    stickyBar.classList.add('is-tucked');
    new IntersectionObserver(function (entries) {
      stickyBar.classList.toggle('is-tucked', entries[0].isIntersecting);
    }).observe(heroEl);
  }

  /* ---------- readout count-up ---------- */
  if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && !(window.Shopify && window.Shopify.designMode)) {
    $$('[data-count]').forEach(function (el) {
      var m = /^(\D*)([\d,]+)(\D*)$/.exec(el.textContent.trim());
      var target = m ? parseInt(m[2].replace(/,/g, ''), 10) : 0;
      if (target < 2) return;
      var start = null;
      var step = function (ts) {
        if (start === null) start = ts;
        var p = Math.min(1, (ts - start) / 1300);
        el.textContent = m[1] + Math.round(target * (1 - Math.pow(1 - p, 3))).toLocaleString('en-US') + m[3];
        if (p < 1) requestAnimationFrame(step);
      };
      el.textContent = m[1] + '0' + m[3];
      setTimeout(function () { requestAnimationFrame(step); }, 450);
    });
  }

  /* ---------- theme editor ---------- */
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target.querySelector('[data-cart-drawer]')) openLayer($('[data-cart-drawer]'));
  });
})();
